import { getFormattedUserCount } from '@/src/shared/utils/userCounts';
import { Section } from '@/src/containers/Landings/Section';
import styles from './JoinSection.module.scss';
import InsuranceLogos from '@/src/containers/SimplifyLandingPageForms/components/JoinOverRow/InsuranceLogos';

interface Props {
  numberOfUsers: number;
}

export default function JoinSection({ numberOfUsers }: Props) {
  return (
    <Section className={styles.container}>
      <h1 className={styles.title}>
        Trusted by <span>{getFormattedUserCount(numberOfUsers)}</span> Industry
        Experts
      </h1>
      <InsuranceLogos iconColor="gray" />
    </Section>
  );
}
